import React, { useEffect, useState } from "react";
import { getCookieValue } from "../../helpers/cookie";

window.dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}

const acceptCookieBar = (statisticsCookies, setShowModal) => {
    try {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 3600 * 24 * 365;
        now.setTime(expireTime);
        document.cookie = "cookiebarok=1;expires=" + now.toGMTString() + ";path=/";
        setShowModal(false);

        gtag('consent', 'update', {
            'ad_user_data': statisticsCookies ? 'granted' : 'denied',
            'ad_personalization': statisticsCookies ? 'granted' : 'denied',
            'ad_storage': statisticsCookies ? 'granted' : 'denied',
            'analytics_storage': statisticsCookies ? 'granted' : 'denied'
        });
    } catch (error) {
        console.error("Hiba történt az acceptCookieBar függvényben: ", error);
    }
}

const denyCookies = (statisticsCookies, setShowModal) => {
    try {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 3600 * 24 * 365;
        now.setTime(expireTime);
        document.cookie = "cookiebarok=0;expires=" + now.toGMTString() + ";path=/";
        setShowModal(false);

        gtag('consent', 'update', {
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'ad_storage': 'denied',
            'analytics_storage': statisticsCookies ? 'granted' : 'denied'
        });
    } catch (error) {
        console.error("Hiba történt a denyCookies függvényben: ", error);
    }
}

const saveCookies = (statisticsCookies, marketingCookies) => {
    try {
        console.log('statisticsCookies', statisticsCookies, 'marketingCookies', marketingCookies);
        var $cookieArray = [];

        var cookieTypes = ["basic"];
        if (statisticsCookies) cookieTypes.push("statistic");
        if (marketingCookies) cookieTypes.push("marketing");
        
        for (var x = 0; x < cookieTypes.length; x++) {
            $cookieArray.push(cookieTypes[x]);
        }

        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 3600 * 24 * 365;
        now.setTime(expireTime);
        document.cookie = "cookies=" + $cookieArray.join(",") + ";expires=" + now.toGMTString() + ";path=/";
    } catch (error) {
        console.error("Hiba történt a saveCookies függvényben: ", error);
    }
}


function CookieModalInfo({ openSettings, setShowModal }) {
    return (
        <>
            <div>
                <h4>Könyvajánlatok, amik neked szólnak</h4>
                <p className="cookie-info">
                Kedves Olvasó! Annak érdekében, hogy a leginkább hozzád illő könyveket ajánlhassuk, valamint a felhasználói élmény növelése, statisztikai adatok gyűjtése és ajánlatok megjelenítése céljából sütiket (cookie-kat) használunk. A „Rendben” gombra kattintva elfogadod, hogy ezeket elmenthetjük a böngésződben. Bővebb információért, illetve a beállítások módosításáért <span onClick={() => openSettings()} style={{cursor: 'pointer', fontWeight: 'bold'}}>kattints ide</span> vagy a “Beállítások” gombra.
                </p>
            </div>

            <div className="cookie-checks">
                <div className="inner">
                    <div className="btn btn-secondary w-100 mb-3" onClick={() => {
                        acceptCookieBar(true, setShowModal);
                        saveCookies(true, true);
                    }}>Rendben</div>
                    <div className="btn-group">
                        <div className="btn btn-secondary mr-1" style={{ backgroundColor: '#C5C7CD' }} onClick={() => openSettings()}>Beállítások</div>
                        <div className="btn btn-secondary ml-1" style={{ backgroundColor: '#C5C7CD' }} onClick={() => {
                            denyCookies(false, setShowModal);
                            saveCookies(false, false);
                        }}>
                            Elutasítom
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function CookieModalSettings({ setShowModal }) {
    const [statisticsCookies, setStatisticsCookies] = useState(true);
    const [marketingCookies, setMarketingCookies] = useState(true);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    return (
        <>
            <p className="cookie-info">
                <div className="form-check new-form-check d-flex" style={{cursor: 'not-allowed'}} data-toggle="tooltip" data-placement="top" title="A feltétlenül szükséges sütik...">
                    <input className="form-check-input" type="checkbox" checked disabled />
                    <label className="form-check-label" />
                    <h3 style={{textDecoration: 'underline'}}>Feltétlenül szükséges sütik</h3>
                </div>
                <div className="form-check new-form-check d-flex" onClick={() => setStatisticsCookies(!statisticsCookies)} style={{cursor: 'pointer'}} data-toggle="tooltip">
                    <input className="form-check-input" type="checkbox" checked={statisticsCookies} />
                    <label className="form-check-label" />
                    <h3 style={{textDecoration: 'underline'}}>Statisztikai sütik</h3>
                </div>
                <div className="form-check new-form-check d-flex" onClick={() => setMarketingCookies(!marketingCookies)} style={{cursor: 'pointer'}} data-toggle="tooltip">
                    <input className="form-check-input" type="checkbox" checked={marketingCookies} />
                    <label className="form-check-label" />
                    <h3 style={{textDecoration: 'underline'}}>Marketing sütik</h3>
                </div>
            </p>
            <div className="cookie-checks">
                <div className="inner">
                    <div className="btn-group">
                        <div className="btn btn-secondary" onClick={() => {
                            acceptCookieBar(statisticsCookies, setShowModal);
                            saveCookies(statisticsCookies, marketingCookies);
                        }}>Mentés</div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default function CookieModal(props) {
    const artUrl = props.elem.dataset.art;

    const [settingsOpen, setSettingsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    
    useEffect(() => {
        const buttonListener = () => setShowModal(true);
        const openButton = document.getElementById("openCookieModalButton");

        if (openButton) {
            openButton.addEventListener("click", buttonListener);
        }

        if (getCookieValue('cookiebarok') !== '1') {
            setShowModal(true);
        }
    
        return () => {
            if (openButton) {
                openButton.removeEventListener("click", buttonListener);
            }
        };
    }, []);

    useEffect(() => {
        setSettingsOpen(false);
    }, [showModal]);

    return (
        <div className="cookie-agree" style={showModal ? {} : {opacity: 0, pointerEvents: 'none'}}>
            <div className="cookies-container">
                <div className="cookies-art">
                    <img src={artUrl} alt="cookies" />
                </div>
                <div className="cookies-content">
                    {!settingsOpen && <CookieModalInfo openSettings={() => setSettingsOpen(true)} setShowModal={setShowModal} />}
                    {settingsOpen && <CookieModalSettings setShowModal={setShowModal} />}
                </div>
            </div>
        </div>
    );
}
